import * as React from "react";
import PropTypes from "prop-types";
import Progress from "./Progress";
import AppWithLogin from "./AppWithLogin";
import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";

/* global Word */

export default class App extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const { title, isOfficeInitialized } = this.props;

    if (!isOfficeInitialized) {
      return (
        <Progress title={title} logo="assets/logo-filled.png" message="Please sideload your addin to see app body." />
      );
    }

    return (
      <div>
        <Router>
        <AppWithLogin />
        </Router>         
        </div>
    );
  }
}

App.propTypes = {
  title: PropTypes.string,
  isOfficeInitialized: PropTypes.bool,
};
